const MAX_LOGO_DATA_URI_CHARS = 70000;

function emitLogoAudit(sample) {
  if (!import.meta.env.DEV || typeof window === "undefined") return;
  try {
    if (!window.__HR_LOGO_AUDIT_CACHE__) {
      window.__HR_LOGO_AUDIT_CACHE__ = new Set();
    }
    const key = `${sample.kind}|${sample.length}|${sample.rejected ? "1" : "0"}`;
    if (window.__HR_LOGO_AUDIT_CACHE__.has(key)) return;
    window.__HR_LOGO_AUDIT_CACHE__.add(key);
    } catch {
    // ignore
  }
}

/**
 * Normalizes a stored image value to a value suitable for <img src>.
 * @param {unknown} raw
 * @returns {string|null}
 */
export function normalizeAgentImageValue(raw) {
  if (raw == null || !String(raw).trim()) return null;
  const s = String(raw).trim();
  if (s.startsWith("data:image")) {
    const rejected = s.length > MAX_LOGO_DATA_URI_CHARS;
    emitLogoAudit({
      source: "agent-image",
      kind: "data-uri",
      length: s.length,
      rejected,
      reason: rejected ? "data_uri_too_large" : "accepted",
    });
    if (rejected) return null;
    return s;
  }
  if (s.startsWith("http://") || s.startsWith("https://")) {
    emitLogoAudit({
      source: "agent-image",
      kind: "remote-url",
      length: s.length,
      rejected: false,
      reason: "accepted",
    });
    return s;
  }
  if (s.startsWith("/") || s.startsWith("./") || s.startsWith("../")) {
    emitLogoAudit({
      source: "agent-image",
      kind: "local-path",
      length: s.length,
      rejected: false,
      reason: "accepted",
    });
    return s;
  }
  const normalized = `data:image/png;base64,${s}`;
  const rejected = normalized.length > MAX_LOGO_DATA_URI_CHARS;
  emitLogoAudit({
    source: "agent-image",
    kind: "base64-raw",
    length: normalized.length,
    rejected,
    reason: rejected ? "base64_too_large" : "accepted",
  });
  if (rejected) return null;
  return normalized;
}

/**
 * Company/agency logo from an agent object (LDS, dynamic order, get_agent_by_id, וכו׳).
 * אותו מיפוי שדות כמו ב־buildCustomerQuoteAgency ב־PackageOrderSummary.
 *
 * @param {import("react").object|null|undefined} agent
 * @returns {string|null} URL / data-URI מוכנים ל־<img src> או null
 */
export function resolveAgentCompanyLogoUrl(agent) {
  if (!agent || typeof agent !== "object") return null;
  const logoRaw =
    agent.companylogobase65 ??
    agent.companyLogoBase65 ??
    agent.company_logo_base64 ??
    null;
  return normalizeAgentImageValue(logoRaw);
}

/**
 * Profile / avatar image URL from an agent object (מיני־סייט, getAgentById, וכו׳).
 * @param {object|null|undefined} agent
 * @returns {string|null}
 */
export function resolveAgentProfilePhotoUrl(agent) {
  if (!agent || typeof agent !== "object") return null;
  const photoRaw =
    agent.avatar ??
    agent.profileImage ??
    agent.profile_image ??
    agent.userimage ??
    agent.UserImage ??
    agent.userImage ??
    agent.photo ??
    null;
  return normalizeAgentImageValue(photoRaw);
}
